import axios from "axios";
import API, { setAuthHeader } from "../../utils/APIUtils";

export const getAllCardDetail = async () => {
    try {

        const token = localStorage.getItem('objectId');
        const apiKey = process.env.REACT_APP_API_KEY;
        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/card-details`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
      

        return response.data;
    } catch (error) {
        console.log("API Error", error);
        if (error.response.data) {
            return error.response.data;
        }
        else if (error.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
}

export const getAllCardInfo = async () => {
    try {

        const token = localStorage.getItem('objectId');
        const apiKey = process.env.REACT_APP_API_KEY;
        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/get-all-cards-info`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }

        })
  
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.data) {
            return error.response.data;
        } else if (error.request) {
            return { messge: 'NO response recived from the server' }
        } else {
            return { messge: error.message }
        }
    }
}

export const getNoOfCardCount = async () => {
    try {
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/card/cards-count`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
       
        return response.data;

    } catch (error) {
        console.log("API error", error);
        if (error.response.data) {
            return error.response.data;
        } else if (error.request) {
            return { messge: 'NO response recived from the server' }
        } else {
            return { messge: error.message }
        }

    }
}

// Define the action
export const getVisitingCard = async ({ encryptedId }) => {
    try {
        const token = localStorage.getItem('objectId');
        const apiKey = process.env.REACT_APP_API_KEY;

        // Define setAuthHeader function
        const setAuthHeader = (token) => {
            if (token) {
                return `Bearer ${token}`;
            } else {
                return null; // Handle cases where the token is not available
            }
        };

        // Call setAuthHeader to get the Authorization header value
        const authHeader = setAuthHeader(token);

    
        // Make the API call with the correct headers
        const response = await API.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/visiting-card`,
            {
                params: {
                    encryptedId,
                },
                headers: {
                    Authorization: authHeader, // Pass the returned value from setAuthHeader
                    'x-api-key': apiKey,
                },
            }
        );

  
        return response.data;
    } catch (error) {
        if (error.response) {
            // API responded with an error status code
            return error.response.data;
        } else if (error.request) {
            // Request was made but no response received
            return { message: 'No response received from the server' };
        } else {
            // Something else caused the error
            return { message: error.message };
        }
    }
};

export const postAttachDocs = async (formData) => {
    const token = localStorage.getItem('objectId');
    const apiKey = process.env.REACT_APP_API_KEY;
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };

    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/uploadDocument`, formData, {
            headers: {
                Authorization: authHeader,
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data"
            }
        });
       

        return response.data;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.message) {
            return error.response.message;
        } else if (error.request) {
            return { message: 'No response received from the server' }
        } else {
            return { message: error.message }
        }
    }
}

export const postCardProfileLogoApi = async (formData) => {
    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/personaldata`, formData, {
            headers: {
                "Content-Type": "multipart/data-form",
                Authorization: authHeader,
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })
        
        return response;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.error) {
            return error.response.message;
        }
        else if (error.request) {
            return { message: 'no response recieved from the servar' }
        } else {
            return { message: error.message }
        }

    }
}


export const getFamilyApi = async (id) => {
    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        if (token) {
            return `Bearer ${token}`;
        } else {
            return null; // Handle cases where the token is not available
        }
    };
    const authHeader = setAuthHeader(token);
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/group-card/${id}`, {
            headers: {
                "Content-Type": "multipart/data-form",
                Authorization: authHeader,
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })
      
        return response;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.error) {
            return error.response.message;
        }
        else if (error.request) {
            return { message: 'no response recieved from the servar' }
        } else {
            return { message: error.message }
        }

    }
}

export const deleteGroupcardMemberApi = async (data) => {
    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };

    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/group-card/delete-member`, data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: setAuthHeader(token),
                    "x-api-key": process.env.REACT_APP_API_KEY
                },

                // This is the correct way to include the payload
            }
        );

      


        return response;
    } catch (error) {
        console.log("API ERROR", error.message);
        if (error.response.error) {
            return error.response.message;
        }
        else if (error.request) {
            return { message: 'no response recieved from the servar' }
        } else {
            return { message: error.message }
        }

    }
};


export const postCreateCardFromOldExperience = async (formData) => {
    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v2/card/create-card-from-old-experience`, formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    Authorization: setAuthHeader(token)
                }
            }
        );

      
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;
        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};

export const postCreateCardWithNewExperience = async (formData) => {
    const token = localStorage.getItem("objectId");

    const setAuth = (token) => {

        return token ? `Bearer ${token}` : null;

    }
    try {

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/card/create-card-with-new-experience`, formData, {
            headers: {
                Authorization: setAuth(token),
                "Content-Type": "multipart/form-data",
                "x-api-key": process.env.REACT_APP_API_KEY,
                // "ngrok-skip-browser-warning": "69420"
            }
        });

       
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;

        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};


export const getCardGetCardForExistingEducation = async (id) => {

    // const token = localStorage.getItem("objectId");

    // const setAuth = (token) => {
    //     return token ? `Bearer${token}` : null;
    // }



    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v2/card/get-cards-for-existing-education/${id}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "x-api-key": process.env.REACT_APP_API_KEY,
                "Content-Type": "application/json"
            }
        });
    
        return response.data;
    } catch (error) {
        console.log("API Error", error);
        if (error.response.error) {
            return error.response.error;

        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};

export const getCardsForExistingExperiences = async (id) => {

    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {


        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v2/card/get-cards-for-existing-experiences/${id}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        });
       

        return response.data;
    } catch (error) {
        console.log("API Error", error);
        if (error.response.error) {
            return error.response.error;

        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};


export const postCreateCardWithNewEducation = async (formData) => {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/card/create-card-with-new-education`, formData,
            {
                headers: {
                    "content-type": "multipart/form-data",
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    Authorization: setAuthHeader(token),
                    // "ngrok-skip-browser-warning": "69420",
                }
            }
        );

      
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;
        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};


export const postCreateCardFromExistingEducation = async (formData) => {
    const token = localStorage.getItem('objectId');
    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v2/card/create-card-from-existing-education`, formData,
            {
                headers: {
                    "content-type": "multipart/form-data",
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    Authorization: setAuthHeader(token),
                    // "ngrok-skip-browser-warning": "69420",
                }
            }
        );


        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;
        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};


export const updateProfessionalCardApi = async (id, data) => {
    const token = localStorage.getItem('objectId');
    const apiKey = process.env.REACT_APP_API_KEY;
    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v3/card/update-card/${id}`, data,
            {
                headers: {
                    Authorization: setAuthHeader(token),
                    "content-type": "multipart/form-data",
                    "x-api-key": apiKey,
                    // "ngrok-skip-browser-warning": "69420"
                }
            }
        );

     
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;
        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};

export const updateStudentCardApi = async (id, data) => {
    const token = localStorage.getItem('objectId');
    const apiKey = process.env.REACT_APP_API_KEY;
    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v3/card/update-card/${id}`, data,
            {
                headers: {
                    Authorization: setAuthHeader(token),
                    "content-type": "multipart/form-data",
                    "x-api-key": apiKey,
                    // "ngrok-skip-browser-warning": "69420"
                }
            }
        );

      
        return response.data;
    } catch (error) {

        console.log("API ERROR", error);
        if (error.response.error) {
            return error.response.error;
        } else if (error.request) {
            return { message: "NOt return from the server side" }
        } else {
            return { message: error.message }
        }
    }
};